function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from '../utils/classNames';
import filterA11YProps from '../utils/filterA11YProps';

var formatCount = function formatCount(number) {
  return number >= 99 ? '99+' : number.toString();
};
/**
 * AlertBubble represents some visual indication of some internal state: number of notifications, if
 * a user is online or not, etc.
 *
 * The AlertBubble implements the Alert component design uses. AlertBubble was not called Alert
 * because an older implementation used the name Alert. In future versions this might be corrected.
 *
 * [Design Spec](https://atlas.np.tools.playstation.net/design/8f0a91de-2d33-43c8-9eb8-57afefdf3f36/3?bounds=-1.886,-0.000,4.772,3.817)
 *
 * ## Related Components
 * - [Button](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/Button/README.md)
 * - [Icon](https://github.sie.sony.com/SIE/web-common-toolkit/tree/master/packages/ui/react-components/src/Icon/README.md)
 *
 * ## Usage
 *
 * Alerts without count.
 *
 * ```jsx
 * <AlertBubble
 *  className="my-class"
 * />
 * ```
 *
 * Alerts with count.
 *
 * ```jsx
 * <AlertBubble
 *  className="my-class"
 *  count={100}
 *  label="100 new messages"
 * />
 * ```
 */


var AlertBubble = /*#__PURE__*/function (_PureComponent) {
  _inherits(AlertBubble, _PureComponent);

  var _super = _createSuper(AlertBubble);

  function AlertBubble() {
    _classCallCheck(this, AlertBubble);

    return _super.apply(this, arguments);
  }

  _createClass(AlertBubble, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          className = _this$props.className,
          count = _this$props.count,
          type = _this$props.type,
          label = _this$props.label,
          disabled = _this$props.disabled,
          otherProps = _objectWithoutProperties(_this$props, ["qa", "className", "count", "type", "label", "disabled"]);

      var _AlertBubble$getClass = AlertBubble.getClassName({
        count: count,
        className: className,
        type: type,
        disabled: disabled
      }),
          root = _AlertBubble$getClass.root;

      if (count === 0) return null;
      return /*#__PURE__*/React.createElement("span", _extends({}, filterA11YProps(otherProps), {
        "data-qa": qa,
        className: root
      }), /*#__PURE__*/React.createElement("span", {
        "aria-hidden": !!label
      }, count != null && formatCount(count)), /*#__PURE__*/React.createElement("span", {
        className: "psw-sr-only"
      }, label));
    }
  }]);

  return AlertBubble;
}(PureComponent);

AlertBubble.defaultProps = {
  qa: '',
  className: '',
  count: null,
  type: '2',
  label: '',
  disabled: false
};
AlertBubble.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Count to show, if not passed "dot" Alert is shown
   */
  count: PropTypes.number,

  /**
   * The type of alert
   * - 1 is white
   * - 2 is blue
   */
  type: PropTypes.oneOf(['1', '2']),

  /**
   * Label for screen reader. This should be used instead of `aria-label` as NVDA
   * does not read aria-labels on spans
   */
  label: PropTypes.string,

  /**
   * Whether or not the AlertBubble is disabled
   */
  disabled: PropTypes.bool
};
/**
 * Gets the classNames attached to the style hooks for this component.
 * @returns {string} the aliased classNames for Alert
 */

AlertBubble.getClassName = function (_ref) {
  var className = _ref.className,
      type = _ref.type,
      count = _ref.count,
      disabled = _ref.disabled;
  var isDot = count == null;
  return {
    root: classNames("psw-alert-".concat(type), disabled && 'psw-is-disabled', 'psw-l-content-box', 'psw-l-inline', 'psw-l-line-center', 'psw-r-pill', 'psw-t-size-3', 'psw-t-bold', isDot ? 'psw-p-r-4 psw-p-b-4' : 'psw-alert-sizing--with-count psw-p-2', className)
  };
};

export default AlertBubble;